import { pesRouterNavigationType } from '@pes-ui/utils';
import { store as pesRouterStore } from './pes-router-store';
export default class PesRoute {
  constructor({ page, pageId, tabId, searchParams, }) {
    this.page = page;
    this.pageId = pageId;
    this.tabId = tabId;
    this.searchParams = searchParams;
  }
  buildAppPath() {
    const path = [
      pesRouterStore.get('base_dir'),
      pesRouterStore.get('country'),
      pesRouterStore.get('language'),
    ];
    if (this.page) {
      path.push(this.page);
    }
    if (this.pageId) {
      path.push(this.pageId);
    }
    return path.join('/');
  }
  get url() {
    if (pesRouterStore.get('navigation') === pesRouterNavigationType.EVENT) {
      return '#';
    }
    if (pesRouterStore.get('navigation') === pesRouterNavigationType.HASH) {
      return `${window.location.origin}${window.location.pathname}#/${this.buildAppPath()}/${this.tabId ? `${this.tabId}/` : ''}`;
    }
    return `${window.location.origin}/${this.buildAppPath()}/${this.tabId ? `#/${this.tabId}/` : ''}`;
  }
}
